import { getErrorPayload } from '@application/common/helpers/api-helper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import ArticalApi from '@infrastructure/article-api';
import { addSuccessNotification } from '../common/notificationSlice';
import WorkOrderApi from '@infrastructure/workorder-api';
export const getArticalByIdAsync = createAsyncThunk('artical/GetById', async (articalId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getArticleById(articalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllArticalsAsync = createAsyncThunk('workorder/GetAllArticals', async (_, { rejectWithValue }) => {
    try {
        const response = await ArticalApi.getAllArticals();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getArticleNumberAsync = createAsyncThunk('Article/GetArticleNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await ArticalApi.getArticleNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createArticleAsync = createAsyncThunk('Article/Create', async (articleObject, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.createArticle(articleObject);
        dispatch(addSuccessNotification('Artikel succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateArticleAsync = createAsyncThunk('Article/Update', async (article, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.updateArticle(article.id, article);
        dispatch(addSuccessNotification('Artikel succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllInStockArticlesAsync = createAsyncThunk('Article/GetAllInStockArticle', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getAllInStockArticles(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllOutOfStockArticlesAsync = createAsyncThunk('Article/GetAllOutOfStockArticle', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getAllOutOfStockArticles(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttachmentsByArticleIdAsync = createAsyncThunk('Article/GetAllAttachmentsByArticleId', async (articleId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getAllAttachmentsByArticleId(articleId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addAttachmentsByArticleIdAsync = createAsyncThunk('Article/UploadArticleAttachment', async (uploadedFile, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.addAttachmentsByArticleId(uploadedFile);
        dispatch(addSuccessNotification("Bestand succesvol geüpload"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteArticleAttachmentAsync = createAsyncThunk('Article/DeleteArticleAttachmentById', async (attachmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.deleteArticleAttachment(attachmentId);
        dispatch(addSuccessNotification("Bijlage succesvol verwijderd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteArticleByIdAsync = createAsyncThunk(`Article/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.deleteArticleById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllOrdersByArticleIdAsync = createAsyncThunk('Article/GetAllOrdersByArticleId', async (articleId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getAllOrdersByArticleId(articleId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllArticlesAsync = createAsyncThunk('Article/GetAllArticles', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.getAllArticles(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllArticleLocationStockByArticleIdAsync = createAsyncThunk('ArticleLocationStock/GetAllArticleLocationStockByArticleId', async (articalId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getAllArticleLocationStockByArticleId(articalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkshopLocationAsync = createAsyncThunk('workshoplocation', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkOrderApi.getWorkshopLocation();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createArticleLocationStockAsync = createAsyncThunk('ArticleLocationStock/Create', async (articleLocationStock, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.createArticleLocationStock(articleLocationStock);
        dispatch(addSuccessNotification('Artikel Voorraad succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getArticleLocationStockByIdAsync = createAsyncThunk('ArticleLocationStock/GetArticleLocationStockById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ArticalApi.getArticleLocationStockById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateArticleLocationStockAsync = createAsyncThunk('ArticleLocationStock/Update', async (articleLocationStock, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.updateArticleLocationStock(articleLocationStock);
        dispatch(addSuccessNotification('Artikel Voorraad succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteArticleLocationStockAsync = createAsyncThunk(`ArticleLocationStock/deleteArticleLocationStock`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await ArticalApi.deleteArticleLocationStock(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
